import React, { Component } from 'react'
import { Field } from 'redux-form'

import ClientUuidsSelector from './clientUuidsSelector'

class ClientUuidsInput extends Component {
  render() {
    if (this.props.source) {
      return <Field component={ClientUuidsSelector} name={this.props.source} {...this.props} />
    } else {
      return <ClientUuidsSelector {...this.props} />
    }
  }
}

export default ClientUuidsInput
